import { render, staticRenderFns } from "./PeoplePage.vue?vue&type=template&id=677016c8"
import script from "./peoplePage.js?vue&type=script&lang=js&external"
export * from "./peoplePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports